import { configureStore } from "@reduxjs/toolkit";
import { isDev, isDebugMode } from "common/utils";
import userSlice from "features/user/slice";
import courseSlice from "features/course/slice";
import parentSlice from "features/parent/slice";
import builderSlice from "features/builder/slice";
import creatorSlice from "features/creator/slice";
import coursesSlice from "features/courses/coursesSlice";
import { subscriptionSlice } from "features/subscription";
import assistantSlice from "features/assistant/assistantSlice";
import configSlice from "./configSlice";

export const store = configureStore({
  reducer: {
    config: configSlice,
    user: userSlice,
    course: courseSlice,
    courses: coursesSlice,
    creator: creatorSlice,
    subscription: subscriptionSlice,
    assistant: assistantSlice,
    parent: parentSlice,
    builder: builderSlice,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: isDev || isDebugMode,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
